module.exports = require('./SearchProviderView');